import { createContext, useContext, useEffect } from 'react';
import { useThemesList } from '@/finsight/application/hooks/apiHooks/useThemesList';

const useArticlesMarketThemes = () => {
  const { getThemesList, isFetching, collection, isInitialized } = useThemesList();

  useEffect(() => {
    getThemesList();
  }, []);

  return { themes: collection, isInitialized, isFetching };
};

type ArticlesMarketThemesContextType = ReturnType<typeof useArticlesMarketThemes>;

const ArticlesMarketThemesContext = createContext<ArticlesMarketThemesContextType>(null);

export const useArticlesThemesContext = () => {
  const context = useContext(ArticlesMarketThemesContext);

  if (!context) {
    throw new Error('useArticlesThemesContext must be used within a ArticlesThemesContextProvider');
  }

  return context;
};

const ArticlesMarketThemesContextProvider = ({ children }) => (
  <ArticlesMarketThemesContext.Provider value={ useArticlesMarketThemes() }>
    { children }
  </ArticlesMarketThemesContext.Provider>
);

export default ArticlesMarketThemesContextProvider;
